import React from 'react';
import './LoadingPage.css';
const LoadingPage = ({
    text, caption
}) => {
    return (
        <div className="loading-page">
            <div className="loading-circle"></div>
            <h2>{text}</h2>
            <p>{caption}</p>
        </div>
    );
};

export default LoadingPage;
